<template>
  <v-container
    grid-list-xl
    fill-height
    fluid>
    <v-layout
      align-center
      justify-center
      row
      wrap>
      <v-dialog
        v-model="dialogMultiPurpose"
        max-width="400px">
        <v-card>
          <v-card-title class="headline">System Message Confirmation</v-card-title>
          <v-card-text>
            {{ dialogMpText }} <br>
          </v-card-text>
          <v-card-actions>
            <v-spacer/>
            <v-btn
              color="red darken-1"
              text
              flat
              @click="dialogMultiPurpose = false"
            >
              Cancel
            </v-btn>

            <v-btn
              color="green darken-1"
              text
              flat
              @click="doDialogAction"
            >
              Ok
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-flex
        xs12
        md12
        lg12>
        <v-card>
          <v-card-actions>
            <v-btn
                dark
                class="mx-1 blue accent-4"
                @click="dialogCreateDefaultShow">Create Default
            </v-btn>
            <v-btn
              dark
              class="mx-1 orange accent-4"
              @click="dialogCancelShow">Cancel All Changes
            </v-btn>
            <v-btn
              color="general"
              dark
              class="mx-1 green darken-1"
              @click="dialogSaveShow">Save All Changes
            </v-btn>
            <v-spacer/>
            <v-btn
              color="general"
              dark
              class="mx-1 blue accent-3"
              @click="$refs.downloadExcel.generate()"
            >
              <download-excel
                ref="downloadExcel"
                :fetch="fetchDataExport"
                :fields="excelFields"
                class="btn btn-default"
                worksheet="worksheet"
                name="ProjectPhase-Task.xls">
                <v-icon>mdi-file-excel</v-icon>&nbsp;
              </download-excel>Export Task
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-flex>
        <v-data-table
          id="phaseDetail"
          :items="DataList"
          :headers="phaseHeaders"
          :expand="true"
          :total-items="totalRows"
          :expanded="true"
          item-key="projectPhase"
          hide-actions
          hide-headers
        >
          <template v-slot:items="props">
            <tr
              class="expandable"
              @click="props.expanded = !props.expanded">
              <td style="width:10px;padding:0 0 0 5px">
                <v-icon
                  large
                  color="blue"
                  @click.stop="addTask(DataList, props)">
                  mdi-plus-box-outline
                </v-icon>
              </td>
              <td>{{ props.item.projectPhase }}</td>
              <td>Completeness: {{ props.item.progress }}%</td>
              <td class="phase-title"><v-edit-dialog
                :return-value.sync="props.item.title"
                lazy
                large
                @save="saveInline"
                @cancel="closeInline"
                @click.native.prevent
                @open="openInline"
              >{{ props.item.title }}
                <template v-slot:input>
                  <v-text-field
                    v-model="props.item.title"
                    placeholder="Edit"
                    single-line
                    counter
                  />
                </template>
              </v-edit-dialog>
              </td>
            </tr>
          </template>
          <template v-slot:expand="props">
            <v-flex mx-3>
              <v-data-table
                id="taskDetail"
                :items="props.item.taskList"
                :headers="taskHeaders"
                item-key="order"
                hide-actions
                dense
              >
                <template v-slot:items="props2">
                  <tr :style="colorChange(props2)">
                    <td style="width:10px;padding:0 0 0 5px">
                      <v-icon
                        medium
                        @click.stop="dialogDeleteShow(props, props2)">delete
                      </v-icon>
                    </td>
                    <td>
                      <v-edit-dialog
                        :return-value.sync="props2.item.desc"
                        lazy
                        large
                        @save="saveInline"
                        @cancel="closeInline"
                        @open="openInline"
                      > {{ props2.item.desc }}
                        <template v-slot:input>
                          <v-text-field
                            v-model="props2.item.desc"
                            :disabled="props2.item.isDone"
                            placeholder="Edit"
                            single-line
                            counter
                          />
                        </template>
                      </v-edit-dialog>
                    </td>
                    <td>
                      <!--                      <v-edit-dialog-->
                      <!--                        :return-value.sync="props2.item.assignedTo"-->
                      <!--                        lazy-->
                      <!--                        @save="saveInline"-->
                      <!--                        @cancel="closeInline"-->
                      <!--                        @open="openInline"-->
                      <!--                      >-->
                      <!--                        {{ (props2.item.assignedTo.username != null ? props2.item.assignedTo.username : '') + (props2.item.assignedTo.employee != null && props2.item.assignedTo.employee.firstName != '' ? (' (' + props2.item.assignedTo.employee.firstName + ')') : '') }}-->
                      <!--                        <template v-slot:input>-->
                      <v-autocomplete
                          v-model="props2.item.assignedTo"
                          :items="userLogins"
                          :rules="[rules.required]"
                          :disabled="props2.item.isDone"
                          :item-text="(item) => {return item.username + ' (' + item.employee.firstName + ')'}"
                          hide-no-data
                          placeholder="Assigned To..."
                          return-object
                          item-value="id"
                      />
<!--                      <v-select-->
<!--                        :items="userLogins"-->
<!--                        v-model="props2.item.assignedTo"-->
<!--                        :disabled="props2.item.isDone"-->
<!--                        :item-text="(item) => {return item.username + ' (' + item.employee.firstName + ')'}"-->
<!--                        menu-props="auto"-->
<!--                        dense-->
<!--                        return-object-->
<!--                        placeholder="Assigned To"-->
<!--                      />-->
                      <!--                        </template>-->
                      <!--                      </v-edit-dialog>-->
                    </td>
                    <td>
                      <!--                      <v-edit-dialog-->
                      <!--                        :return-value.sync="props2.item.startDate"-->
                      <!--                        @close="deleteInline"-->
                      <!--                        @save="saveInline"-->
                      <!--                        @cancel="closeInline"-->
                      <!--                        @open="openInline"-->
                      <!--                      >{{ props2.item.startDate }}-->
                      <!--                        <template v-slot:input>-->
                      <v-menu
                        v-model="menuDatePickers[props.item.id+'st'+props2.index]"
                        :nudge-right="40"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        full-width
                        max-width="290px"
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="props2.item.startDate"
                            prepend-icon="event"
                            readonly
                            v-on="on"
                          />
                        </template>
                        <v-date-picker
                          v-model="props2.item.startDate"
                          :disabled="props2.item.isDone"
                          no-title
                          scrollable
                          color="blue"
                          @input="menuDatePickers[props.item.id+'st'+props2.index] = false" />
                      </v-menu>
                      <!--                        </template>-->
                      <!--                      </v-edit-dialog>-->
                    </td>
                    <td class="">
                      <!--                      <v-edit-dialog-->
                      <!--                        :return-value.sync="props2.item.endDate"-->
                      <!--                        lazy-->
                      <!--                        large-->
                      <!--                        @save="saveInline"-->
                      <!--                        @cancel="closeInline"-->
                      <!--                        @open="openInline"-->
                      <!--                      >{{ props2.item.endDate }}-->
                      <!--                        <template v-slot:input>-->
                      <v-menu
                        :close-on-content-click="false"
                        v-model="menuDatePickers[props.item.id+'ed'+props2.index]"
                        :nudge-right="40"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        max-width="290px"
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="props2.item.endDate"
                            prepend-icon="event"
                            readonly
                            v-on="on"
                          />
                        </template>
                        <v-date-picker
                          v-model="props2.item.endDate"
                          :disabled="props2.item.isDone"
                          no-title
                          scrollable
                          color="blue"
                          @input="menuDatePickers[props.item.id+'ed'+props2.index] = false"/>
                      </v-menu>
                      <!--                        </template>-->
                      <!--                      </v-edit-dialog>-->
                    </td>

                    <td class="">{{ props2.item.approveDateTime != null? toStringDateOnly(props2.item.approveDateTime) : 'N/A' }}</td>
                    <td>
                      <v-btn
                        v-if="props2.item.isDone"
                        color="mx-0 red darken-1"
                        dark
                        @click.stop="approveAction(props2)">Reject</v-btn>
                      <v-btn
                        v-else
                        color="mx-0 green darken-1"
                        dark
                        @click.stop="approveAction(props2)">Aprrove</v-btn>
                    </td>
<!--                    <td class="">{{ props2.item.approveBy != null? props2.item.approveBy.username + ' (' + props2.item.approveBy.employee.firstName +')' : 'N/A' }}</td>-->
                  </tr>
                </template>
              </v-data-table>
            </v-flex>
          </template>
        </v-data-table>
      </v-flex>
      <v-flex
        xs12
        md12
        lg12>
        <v-card>
          <v-card-actions>
            <v-btn
                dark
                class="mx-1 blue accent-4"
                @click="dialogCreateDefaultShow">Create Default
            </v-btn>
            <v-btn
              dark
              class="mx-1 orange accent-4"
              @click="dialogCancelShow">Cancel All Changes
            </v-btn>
            <v-btn
              color="general"
              dark
              class="mx-1 green darken-1"
              @click="dialogSaveShow">Save All Changes
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import displayFormatterMixins from '../../../mixins/displayFormatterMixins'
  import _ from 'lodash'
  import axios from 'axios'
  import {mapGetters} from 'vuex'

  export default {
    name: 'ProDetPhase',
    mixins: [displayFormatterMixins],
    props: {
      pid: String
    },
    data: () => {
      return ({
        menuPropsSelect: {
          'closeOnClick': false, 'closeOnContentClick': true, 'openOnClick': false, 'maxHeight': 300
        },
        menuDatePickers: {},
        menu: [],
        deletedRecord: {},
        snack: false,
        valid: false,
        lazy: false,
        snackColor: '',
        snackText: '',
        rules: {
          required: value => !!value || 'Required.',
          max50chars: value => !value || value.length <= 50 || 'Max 50 characters',
          email: value => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return !value || pattern.test(value) || 'Invalid e-mail.'
          },
          number: value => !isNaN(value) || 'Must be numeric'
        },
        expand: true,
        DataList: [],
        userLogins: [],
        totalRows: 10,
        dialogMultiPurpose: false,
        dialogMpAction: '',
        dialogMpText: '',
        loading: true,
        taskDto: {
          order: 0,
          assignedTo: {
            id: '',
            username: '',
            employee: {
              firstName: ''
            }
          },
          approveBy: {
            id: '',
            username: '',
            employee: {
              firstName: ''
            }
          },
          updateBy: '',
          updateTime: '',
          startDate: '',
          endDate: '',
          desc: '',
          isDone: false
        },
        phaseHeaders: [
          { text: '', value: 'action', sortable: false },
          { text: 'Phase', value: 'title', sortable: false },
          { text: 'Title', value: 'title', sortable: false },
          { text: 'Progress', value: 'title', sortable: false }
        ],
        taskHeaders: [
          { text: '', value: '', sortable: false },
          { text: 'Task', value: 'desc', sortable: false },
          { text: 'Assigned To', value: 'assignedTo', sortable: false },
          { text: 'Start Date', value: 'startDate', sortable: false },
          { text: 'End Date', value: 'endDate', sortable: false },
          { text: 'Approve Time', value: 'approveDateTime', sortable: false },
          { text: 'Approve/Reject', value: '', sortable: false },
          // { text: 'App/Rej By', value: 'approveBy', sortable: false }
        ],
        excelFields: {
          'Phase': 'projectPhase',
          'Phase Title': 'projectPhaseTitle',
          'Task': 'desc',
          'Assigned To': {
            callback: (value) => {
              if (value.assignedTo) {
                return `${value.assignedTo.username} (${value.assignedTo.employee.firstName})`
              } else {
                return ''
              }
            }
          },
          'Start Date Time': {
            callback: (value) => {
              if (value.startDate) {
                return new Date(value.startDate).toLocaleDateString('en-GB')
              } else {
                return ''
              }
            }
          },
          'End Date Time': {
            callback: (value) => {
              if (value.endDate) {
                return new Date(value.endDate).toLocaleDateString('en-GB')
              } else {
                return ''
              }
            }
          },
          'Approve Date': {
            callback: (value) => {
              if (value.approveDateTime) {
                return new Date(value.approveDateTime).toLocaleDateString('en-GB')
              } else {
                return ''
              }
            }
          },
        },
        searchUserLogins: '',
      })
    },
    computed: {
      ...mapGetters(['hasPermission']), // without modules
    },

    watch: {
      // TODO server virtual scrolling
      // searchUserLogins () {
      //   if (this.searchUserLogins && this.searchUserLogins.length >= 3) {
      //     this.debouncedGetUserLogins()
      //   }
      // }
    },
    // called when page is created before dom
    created () {
      this.getUserLogins()
      // TODO server virtual scrolling
      // this.debouncedGetUserLogins = _.debounce(this.getUserLoginsPaging, 500)
      this.getProjectDetPhase()
    },
    mounted () {
      console.debug(this.pid)
    },
    methods: {
      async fetchDataExport () {
        const response = await this.$http.get(`/api/project/detailphase/export/${this.pid}`)
        if (response.data.length < 1) {
          this.cancelInline('Fail export, Tasks not found')
        }
        return response.data
      },
      colorChange (props2) {
        let css = props2.item.isDone ? 'background-color: honeydew' : 'palegreen' // honeydrew, lightgreen
        return css
      },
      usernameItemText (item) {
        if (item.employee) { // bug workaround
          return item.username + ' (' + item.employee.firstName + ')'
        } else {
          return item.username
        }
      },
      dialogCancelShow (parent, child) {
        this.dialogMultiPurpose = true
        this.dialogMpText = 'WARNING: Are you sure want to cancel/undo all changes?'
        this.dialogMpAction = 'CANCEL'
      },
      dialogSaveShow (parent, child) {
        this.dialogMultiPurpose = true
        this.dialogMpText = 'WARNING: Are you sure want to proceed save all these changes?'
        this.dialogMpAction = 'SAVE'
      },
      dialogDeleteShow (parent, child) {
        if (child.item.isDone === true && child.item.approveDateTime != null) {
          this.cancelInline('ERROR: Task already Approved')
          return
        }
        this.dialogMultiPurpose = true
        this.dialogMpText = 'WARNING: Are you sure want to proceed delete this record?'
        this.dialogMpAction = 'DELETE'
        this.deletedRecord = {
          phase: parent.item,
          task: child.item
        }
      },
      dialogCreateDefaultShow (parent, child) {
        this.dialogMultiPurpose = true
        this.dialogMpText = 'WARNING: It will create default tasks and OVERWRITE existing tasks! Are you sure want to proceed?'
        this.dialogMpAction = 'CREATE_DEFAULT'
      },
      async doDialogAction () {
        if (this.dialogMpAction === 'DELETE') {
          this.deleteTask()
        } else if (this.dialogMpAction === 'SAVE') {
          this.save()
        } else if (this.dialogMpAction === 'CANCEL') {
          this.dialogMultiPurpose = false
          this.getProjectDetPhase()
        } else if (this.dialogMpAction === 'CREATE_DEFAULT') {
          this.dialogMultiPurpose = false
          this.createDefault()
        }
      },
      async createDefault () {
        const response = await this.$http.get(`/api/project/detailphase/default/${this.pid}`)
        console.debug(response.data)
        this.DataList = response.data

      },
      async deleteTask () {
        let record = this.deletedRecord
        this.dialogMultiPurpose = false
        let newTaskList = _.filter(record.phase.taskList, o => o.order !== record.task.order)
        let i = 1
        console.debug(newTaskList)
        record.phase.taskList = _.map(newTaskList, e => {
          e.order = i
          i++
          return e
        })
        console.debug(record.phase.taskList)
      },

      async addTask (dataList, props) {
        let newTask = Object.assign({}, this.taskDto)
        newTask.order = props.item.taskList.length + 1
        props.item.taskList.push(newTask)
        console.debug(props.item.taskList)
        props.expanded = true
      },

      async validateSave () {
        let valid = true
        _.forEach(this.DataList, async el => {
          console.debug(el)
          await _.forEach(el.taskList, row => {
            console.debug(row)
            if (row.desc == '' || row.startDate == '' || row.endDate == '' || row.assignedTo.username == '') {
              valid = false
              this.cancelInline('Failed to Save. Some of the Task are empty!')
              return false
            }
          })
          if (!valid) {
            return valid
          }
        })
        return valid
      },
      async save () {
        let valid = await this.validateSave()
        this.dialogMultiPurpose = false
        if (!valid) {
          return
        }
        let tableItem = this.DataList
          let endpoint = `api/project/detailphase`
          let method = 'patch'
          try {
            let response = await this.$store.dispatch('updateTableItem', { endpoint, tableItem, method })
            if (response.data.message === 'FAILED') {
              this.cancelInline(response.data.details)
              return
            }
            this.$emit('refresh') // call parent action + params
            this.saveInline()
            this.getProjectDetPhase()
          } catch (error) {
            console.log(error)
            this.cancelInline()
          }
      },
      async approveAction (props2) {
        // TODO check to BE
        if (this.hasPermission('PRO_APPROVE_TASK') === true) { // client validation
          props2.item.isDone = !props2.item.isDone
          // if (!props2.item.approveBy) {
          //   props2.item.approveBy = this.taskDto.approveBy
          // }
          // props2.item.approveBy.username = this.user.username
          // props2.item.approveBy.employee.firstName = this.user.fullname
          props2.item.updateBy = localStorage.getItem('username')
          props2.item.updateTime = new Date()
          if (props2.item.isDone) {
            props2.item.approveDateTime = new Date()
          } else {
            props2.item.approveDateTime = null
          }
        } else {
          this.cancelInline("You don't have the permission to Approve/Reject")
        }
      },
      async getProjectDetPhase () {
        const response = await this.$http.get(`/api/project/detailphase/${this.pid}`)
        console.debug(response.data)
        this.DataList = response.data
      },
      async getUserLoginsPaging () { // paging not yet implemented
        try {
          console.debug('-- get userlogins-- ' + this.searchUserLogins)
          let q = this.searchUserLogins == null ? '' : this.searchUserLogins
          let response = await this.$http.get(`api/userlogin/autocomplete?ps=100&pn=0&so=name&q=${q}`)
          console.debug(response.data)
          this.userLogins = response.data
        } catch (error) {
          console.log(error)
        }
      },
      async getUserLogins () {
        try {
          let response = await this.$http.get(`/api/userlogin/select`)
          this.userLogins = response.data
        } catch (error) {
          console.log(error)
        }
      },
      // toasts/snackbar messages for actions
      saveInline () {
        this.$emit('callSnack', 'saveInline') // call parent action + params
      },
      cancelInline (message) {
        this.$emit('callSnack', 'cancelInline', message) // call parent action + params
      },
      deleteInline () {
        this.$emit('callSnack', 'deleteInline') // call parent action + params
      },
      openInline () {
        this.$emit('callSnack', 'openInline') // call parent action + params
      },
      closeInline () {
        this.$emit('callSnack', 'closeInline') // call parent action + params
      }
    }
  }
</script>

<style>
  #taskDetail thead tr {
    background-color: aliceblue;
  }
  /*#phaseDetail .phase-title .v-small-dialog {*/
  /*  width: fit-content;*/
  /*}*/

  #taskDetail table.v-table thead tr th {
    font-size: 1.25em;
  }
</style>
